import React from 'react';
import { IconTooltip } from 'utils/components/IconTooltip';
import { Icon } from '@instinet-analytics/semantic-ui-components';

export function VolumeCurveHelpText() {
    return (
        <>
            <div>
                This chart provides a view of the volume curve for the selected
                order.
            </div>
            <div>
                The data is grouped into time bins which can be changed via the
                widget&apos;s configuration tool <Icon name="cog" /> from the
                options menu <Icon name="ellipsis horizontal" />.
            </div>
            <div>
                The start time is based on the selected order. The same for the
                end time, if available (otherwise it will default to EOD). You
                can edit the start and end time by clicking on{' '}
                <Icon name="edit" /> and reset back to the defaults by clicking{' '}
                <Icon name="trash" />.
            </div>
            <div>
                Toggle between the chart and table view by using the options
                menu <Icon name="ellipsis horizontal" />
            </div>
        </>
    );
}

export default function VolumeCurveHelp() {
    return (
        <div style={{ marginLeft: '5px', marginTop: '-1px' }}>
            <IconTooltip>
                <VolumeCurveHelpText />
            </IconTooltip>
        </div>
    );
}
